import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const deviceConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default deviceConfig;
